let refreshTimer = null;
let isRefreshing = false;
let lastUpdateAt = null;
let pendingRefresh = false;

function applyRowStatusClass(row, status, isLate) {
    if (!row) return;

    row.classList.remove(
        "status-row-pending",
        "status-row-dispatched",
        "status-row-in-transit",
        "status-row-completed",
        "status-row-cancelled",
        "late-row",
    );

    const statusClassByValue = {
        pending: "status-row-pending",
        dispatched: "status-row-dispatched",
        in_transit: "status-row-in-transit",
        completed: "status-row-completed",
        cancelled: "status-row-cancelled",
    };

    const statusClass = statusClassByValue[status];
    if (statusClass) {
        row.classList.add(statusClass);
    } else if (isLate) {
        row.classList.add("late-row");
    }
}

function updateDashboardNote(note) {
    if (!note) return;

    // Update CKEditor if it is active
    const editor = window._dashboardCKEditor;
    if (editor) {
        const current = editor.getData();
        if (current !== (note.content || "")) {
            editor.setData(note.content || "");
        }
        return;
    }

    // Fallback: plain textarea
    const textarea = document.getElementById("dashboard-notes");
    if (textarea && textarea.value !== (note.content || "")) {
        textarea.value = note.content || "";
    }
}

function updateFormDataLists(data) {
    // Mettre à jour la datalist des heures (formulaire d'ajout)
    const serviceRoutesListForm = document.getElementById(
        "serviceRoutesListForm",
    );
    if (serviceRoutesListForm && data.service_routes) {
        serviceRoutesListForm.innerHTML = data.service_routes
            .map((h) => `<option value="${h.name}">`)
            .join("");
    }

    // Mettre à jour la datalist des services/routes (tableau - lignes modifiables)
    const sharedServiceRoutesList = document.getElementById(
        "sharedServiceRoutesList",
    );
    if (sharedServiceRoutesList && data.service_routes) {
        sharedServiceRoutesList.innerHTML = data.service_routes
            .map((h) => `<option value="${h.name}">`)
            .join("");
    }

    // Mettre à jour la datalist des routes/expéditions (formulaire d'ajout)
    const deliveryRunsListForm = document.getElementById(
        "deliveryRunsListForm",
    );
    if (deliveryRunsListForm && data.deliveryRuns) {
        deliveryRunsListForm.innerHTML = data.deliveryRuns
            .map((r) => `<option value="${r.name}">`)
            .join("");
    }

    // Mettre à jour la datalist des routes/expéditions (tableau - lignes modifiables)
    const sharedDeliveryRunsList = document.getElementById(
        "sharedDeliveryRunsList",
    );
    if (sharedDeliveryRunsList && data.deliveryRuns) {
        sharedDeliveryRunsList.innerHTML = data.deliveryRuns
            .map((r) => `<option value="${r.name}">`)
            .join("");
    }

    // Mettre à jour la datalist des destinations (formulaire d'ajout)
    const destinationsListForm = document.getElementById(
        "destinationsListForm",
    );
    if (destinationsListForm && data.destinations) {
        destinationsListForm.innerHTML = data.destinations
            .map((d) => `<option value="${d.name}">`)
            .join("");
    }

    // Mettre à jour la datalist des destinations (tableau - lignes modifiables)
    const sharedDestinationsList = document.getElementById(
        "sharedDestinationsList",
    );
    if (sharedDestinationsList && data.destinations) {
        sharedDestinationsList.innerHTML = data.destinations
            .map((d) => `<option value="${d.name}">`)
            .join("");
    }

    // Mettre à jour le select des employés (formulaire d'ajout)
    const employeeSelect = document.getElementById("employee_id");
    if (employeeSelect && data.employees) {
        const selectedValue = employeeSelect.value;
        employeeSelect.innerHTML =
            '<option value="">-- Sélectionner un employé --</option>' +
            data.employees
                .map(
                    (e) =>
                        `<option value="${e.id}" ${e.id == selectedValue ? "selected" : ""}>${e.firstname} ${e.lastname}</option>`,
                )
                .join("");
    }

    // Mettre à jour tous les selects d'employés dans les lignes du tableau
    const employeeSelects = document.querySelectorAll(
        'select.update-field[data-field="employee_id"]',
    );
    employeeSelects.forEach((select) => {
        if (data.employees) {
            const selectedValue = select.value;
            const selectedOption = select.options[select.selectedIndex];
            const selectedText = selectedOption
                ? selectedOption.textContent
                : "";
            const isSelectedInList = data.employees.some(
                (e) => String(e.id) === String(selectedValue),
            );
            select.innerHTML =
                '<option value="">-- Sélectionner un employé --</option>' +
                (!isSelectedInList && selectedValue
                    ? `<option value="${selectedValue}" selected>${selectedText}</option>`
                    : "") +
                data.employees
                    .map(
                        (e) =>
                            `<option value="${e.id}" ${e.id == selectedValue ? "selected" : ""}>${e.firstname} ${e.lastname}</option>`,
                    )
                    .join("");
        }
    });
}

function updateRowData(row, assignment) {
    const currentStatus = Array.from(
        row.querySelectorAll(".status-toggle"),
    ).find((cb) => cb.checked)?.dataset.status;

    if (currentStatus !== assignment.status) {
        row.querySelectorAll(".status-toggle").forEach((cb) => {
            cb.checked = cb.dataset.status === assignment.status;
        });
    }

    const dateDisplay = document.getElementById("currentDateDisplay");
    const todayDate =
        dateDisplay?.dataset.serverToday || dateDisplay?.dataset.serverDate;
    const isLate =
        new Date(assignment.scheduled_at) < new Date(todayDate) &&
        assignment.status !== "completed" &&
        assignment.status !== "cancelled";

    applyRowStatusClass(row, assignment.status, isLate);
}

function updateTableRows(assignments) {
    const tbody = document.getElementById("mainAssignmentsTable");
    if (!tbody) return;

    const activeElement = document.activeElement;
    const isFocused = activeElement && tbody.contains(activeElement);
    const focusedId = isFocused
        ? activeElement.closest("tr")?.dataset.id
        : null;

    assignments.forEach((assignment) => {
        const row = tbody.querySelector(`tr[data-id="${assignment.id}"]`);

        if (row) {
            if (focusedId && focusedId === String(assignment.id)) {
                return;
            }
            updateRowData(row, assignment);
        } else {
            // New assignment detected: force a full data refresh without page reload
            refreshAssignments({ force: true });
            return;
        }
    });

    const currentIds = assignments.map((a) => String(a.id));
    const rows = tbody.querySelectorAll("tr[data-id]");

    rows.forEach((row) => {
        const rowId = row.dataset.id;
        if (!currentIds.includes(rowId)) {
            // Deleted assignment detected: force refresh without page reload
            refreshAssignments({ force: true });
        }
    });
}

function applyRowsHtml(rowsHtml) {
    const tbody = document.getElementById("mainAssignmentsTable");
    if (!tbody) return false;

    // Preserve page scroll position across DataTables redraws
    const savedScrollY = window.scrollY;

    if (
        window.dashboardDataTable &&
        typeof window.dashboardDataTable.clear === "function"
    ) {
        const tempBody = document.createElement("tbody");
        tempBody.innerHTML = rowsHtml || "";
        const rows = Array.from(tempBody.querySelectorAll("tr"));

        window.dashboardDataTable.clear();
        if (rows.length) {
            window.dashboardDataTable.rows.add(rows);
        }
        window.dashboardDataTable.draw(false);
        // Restore after DataTables redraws (next paint)
        requestAnimationFrame(() =>
            window.scrollTo({ top: savedScrollY, behavior: "instant" }),
        );
        return true;
    }

    tbody.innerHTML = rowsHtml || "";
    requestAnimationFrame(() =>
        window.scrollTo({ top: savedScrollY, behavior: "instant" }),
    );
    return true;
}

export function refreshAssignments(options = {}) {
    if (isRefreshing) {
        pendingRefresh = true;
        return;
    }

    const dateDisplay = document.getElementById("currentDateDisplay");
    const currentDate = dateDisplay?.dataset.serverDate;
    if (!currentDate) return;

    isRefreshing = true;

    const query = new URLSearchParams({ date: currentDate });
    if (lastUpdateAt && !options.force) {
        query.set("since", lastUpdateAt);
    }

    fetch(`/deliveries/refresh?${query.toString()}`, {
        method: "GET",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
        },
    })
        .then((response) => response.json())
        .then((data) => {
            if (!data.success) return;

            if (data.last_update_at) {
                lastUpdateAt = data.last_update_at;
            }

            if (data.changed === false) {
                return;
            }

            // Update dashboard notes if provided
            if (data.dashboardNote) {
                updateDashboardNote(data.dashboardNote);
            }

            if (typeof data.rows_html === "string") {
                const applied = applyRowsHtml(data.rows_html);
                if (!applied) {
                    updateTableRows(data.assignments);
                }
            } else {
                updateTableRows(data.assignments);
            }

            updateFormDataLists(data);
            console.log(
                `Données rafraîchies: ${data.assignments.length} assignments`,
            );
        })
        .catch((error) => {
            console.error("Erreur lors du refresh:", error);
        })
        .finally(() => {
            isRefreshing = false;
            if (pendingRefresh) {
                pendingRefresh = false;
                refreshAssignments(options);
            }
        });
}

export function startAutoRefresh() {
    refreshTimer = setInterval(() => {
        refreshAssignments();
    }, 30000);
    console.log("Auto-refresh activé (30 secondes)");
}

export function stopAutoRefresh() {
    if (refreshTimer) {
        clearInterval(refreshTimer);
        refreshTimer = null;
        console.log("Auto-refresh désactivé");
    }
}

// ── WebSocket (Reverb / Echo) ─────────────────────────────────────────────────

let echoChannel = null;

/**
 * Start listening for server-push events via Laravel Echo (Reverb).
 * Falls back to polling every 30 s when Echo is not available.
 */
export function startBroadcastRefresh() {
    if (window.Echo) {
        echoChannel = window.Echo.channel("dashboard").listen(
            ".data.changed",
            () => {
                refreshAssignments();
            },
        );
        console.log("Dashboard: WebSocket Reverb activé");
    } else {
        startAutoRefresh();
        console.log("Dashboard: Echo non disponible, polling 30 s activé");
    }
}

export function stopBroadcastRefresh() {
    if (echoChannel) {
        window.Echo?.leaveChannel("dashboard");
        echoChannel = null;
    }
    stopAutoRefresh();
}
